export default __webpack_public_path__ + "static/media/section-activity-illustration-club.6e8f855f.svg";